(function(){
  if(!window.SergeVideoLazyload){
    window.SergeVideoLazyload = {};
    window.SergeVideoLazyload.onLoad = function(){
      let videoPlayers = document.querySelectorAll('.serge-videolazyload');
      let videoPlayerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play();
            videoPlayerObserver.unobserve(entry.target);
          }
        });
      });
      videoPlayers.forEach(function(player){
        videoPlayerObserver.observe(player);
      });
      console.log(videoPlayers)
    };
    window.SergeVideoLazyload.onLoad();
  }
})();